module.exports = __webpack_public_path__ + "img/wordpress_1.4d411cae.png";